<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .wrapper {
    flex-grow: 1;

    .input-wrapper {
      width: 100%;
      border-radius: utils.in_rem(10px);
      outline: 1.4px solid colors.get(interfaceSwGrey_10);
      @include colors.background-color(interfaceWhite);

      display: flex;
      flex-direction: row;
      align-items: center;
      align-self: stretch;
      gap: utils.in_rem(4px);
      padding: utils.in_rem(4px) utils.in_rem(4px) utils.in_rem(4px)
        utils.in_rem(12px);

      > input,
      > textarea {
        flex: 1;
        border: none;
        width: 100%;
        &:focus {
          outline: none;
        }
      }

      > input {
        height: utils.in_rem(22px);
      }

      > textarea {
        field-sizing: content;
        min-height: utils.in_rem(22px);
        max-height: utils.in_rem(110px);
        resize: none;
        overflow-y: auto;
      }

      &:not(.success):not(.error):not(.disabled):focus-within {
        outline: 2px solid colors.get(primary_40);
      }

      &:not(.disabled).error {
        outline: 2px solid colors.get(systemError_100);
      }

      &.disabled {
        @include colors.background-color(interfaceDisabledGrey_5);
        @include colors.color(textDisabledGrey);
      }
    }

    .helper-text-wrapper {
      display: flex;
      gap: utils.in_rem(4px);
      align-items: center;
      padding: utils.in_rem(6px) 0 0 utils.in_rem(4px);
      @include mixins.body3-tooltip-and-caption();
      @include colors.color(textGrey);

      &.error {
        @include colors.color(systemError_100);
      }

      &.success {
        @include colors.color(systemPositive_100);
      }

      &.info {
        @include colors.color(systemInformation_100);
      }
    }
  }
</style>

<script>
  import Icon from "../../atoms/Icon.svelte";
  import IconScale from "../../atoms/IconScale.svelte";

  export let leadingIcon = "";
  export let placeholder = "";
  export let value;
  export let style = "";
  export let helperText = "";
  export let state = ""; // can be "error" or "success"
  export let disabled = false;
  export let allowMultiline = false; // allow Shift+Enter for new lines
  export let onclick = () => {}; // pass button onclick to trigger when enter is pressed

  let el;

  export const focus = () => el?.focus();

  export const onkeydown = (e) => {
    if (!["Enter"].includes(e.key)) return;

    // If multiline is allowed and Shift+Enter is pressed, add new line
    if (allowMultiline && e.shiftKey) return;

    // Otherwise, prevent default and submit
    e.preventDefault();
    focus();
    if (value) onclick();
  };
</script>

<div class="wrapper">
  <div
    class="input-wrapper {state} {disabled ? 'disabled' : ''}"
    on:click={focus}
    on:{focus}
    tabindex="-1"
    role="tab"
    on:keydown={onkeydown}
    {style}
  >
    {#if leadingIcon}
      <IconScale class={leadingIcon} size="small" />
    {/if}
    {#if allowMultiline}
      <textarea bind:this={el} bind:value {placeholder} {disabled}></textarea>
    {:else}
      <input bind:this={el} bind:value {placeholder} {disabled} />
    {/if}
    <slot />
  </div>
  {#if helperText}
    <div class="helper-text-wrapper {state}">
      {#if state === "error"}
        <Icon class="fas fa-exclamation-circle" size="xs" />
      {:else if state === "success"}
        <Icon class="fas fa-check-circle" size="xs" />
      {:else if state === "info"}
        <Icon class="fas fa-info-circle" size="xs" />
      {/if}
      <span class="helper-text"
        >{helperText} <slot name="helper-text-link" /></span
      >
    </div>
  {/if}
</div>
